import { useState } from 'react';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const useFiltersView = () => {
  const { closeTray, enableManualSelection, expectModeToBe, restoreFilters, setFilters, setMode, upsertAudience } =
    useAudienceTray();
  const [resetKey, setResetKey] = useState(0);

  const resetFilters = () => {
    setFilters({});
    setResetKey((prev) => prev + 1);
  };

  const applyFilters = () => {
    expectModeToBe(['filters'], 'applyFilters');

    // Filters > Apply Filters (Manual Selection): Go to All Contacts tab.
    // TODO: Should the recipients list be disabled/enabled to prevent unnecessary fetches?
    if (enableManualSelection) {
      setMode('recipients');
    }

    // Filters > Create Segment (Segment Creation): Go to Segments tab
    else {
      upsertAudience();
      setFilters({});
      setMode('segments');
      closeTray();
    }
  };

  // Filters > Back Button: Restore Saved Lists > Create List Button: Stash recipient selection. Go to All Contacts tab.
  const cancelFilters = () => {
    expectModeToBe(['filters'], 'cancelFilters');

    // Filters > Back Button (Manual Selection): Restore Filters. Go to All Contacts tab.
    // TODO: Should the recipients list be disabled/enabled to prevent unnecessary fetches?
    if (enableManualSelection) {
      restoreFilters(); // TODO: Work on properly saving the current filters state when navigating to the filters view
      setMode('recipients');
    }

    // Filters > Back Button (Segment Creation): Go to Segments tab
    else {
      setFilters({});
      setMode('segments');
    }
  };

  return {
    applyFilters,
    cancelFilters,
    resetFilters,
    resetKey,
  };
};
